import script from "./AIThinkingOverlay.vue?vue&type=script&lang=ts&setup=true"
export * from "./AIThinkingOverlay.vue?vue&type=script&lang=ts&setup=true"

import "./AIThinkingOverlay.vue?vue&type=style&index=0&id=45fb2506&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45fb2506"]])

export default __exports__